import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SWOffering from "@/pages/SWOffering";

export const Route = createFileRoute("/es/servicios/software-solutions-services/cualificación-de-la-infraestructura-informática")({
  head: () => buildRouteHead("/es/servicios/software-solutions-services/cualificación-de-la-infraestructura-informática"),
  component: SWOffering,
});

